export default __webpack_public_path__ + "static/makit-titulbilde-139919a3810f09d2591a81c198f9a0fe.jpg";